/**
 * BLOCK: FAQ - Deprecated Block
 */

import classnames from 'classnames';
import attributes from './attributes';
import { InnerBlocks } from '@wordpress/block-editor';

const deprecated = [
	{
		attributes,
		save(props) {
			const { className } = props
			const {
				block_id,
				schema,
				enableSchemaSupport,
				equalHeight
			} = props.attributes

			const renderSchema = () => {

				if (true === enableSchemaSupport) {

					return (
						<script type="application/ld+json">
							{schema}
						</script>
					)
				}

				return '';
			}

			const equalHeightClass = equalHeight ? "wpsp-faq-equal-height" : "";

			return (
				<div className={classnames(
					className,
					"wpsp-faq__outer-wrap",
					`wpsp-block-${block_id}`,
					`wpsp-faq-icon-${props.attributes.iconAlign}`,
					`wpsp-faq-layout-${props.attributes.layout}`,
					`wpsp-faq-expand-first-${props.attributes.expandFirstItem}`,
					`wpsp-faq-inactive-other-${props.attributes.inactiveOtherItems}`,
					equalHeightClass
				)}
					data-faqtoggle={props.attributes.enableToggle}
				>
					{renderSchema()}
					<div className="wpsp-faq__wrap wpsp-buttons-layout-wrap">
						<InnerBlocks.Content />
					</div>
				</div>
			)

		}
	},
];

export default deprecated;
